export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
  chapterNumber: number;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categories: string[];
  description: string;
  rating: number;
  views: number;
  status: "连载中" | "已完结";
  updateDate: string;
  tags: string[];
  chapters: ComicChapter[];
  longDescription: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "她的心动日记",
    author: "金智恩",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20manga%20cover%20art%2C%20beautiful%20young%20woman%20with%20long%20dark%20hair%20blushing%20in%20a%20cherry%20blossom%20park%2C%20soft%20pastel%20pink%20and%20white%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20lineart%2C%20manhwa%20illustration%20style%2C%20simple%20solid%20pink%20background%20with%20subtle%20cherry%20blossom%20petals%20falling&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    category: "romance",
    categories: ["romance", "daily"],
    description: "平凡的女高中生林小柔，在转学的第一天就遇到了校园里的风云人物。一段青涩甜蜜的校园恋爱故事就此展开。",
    rating: 4.8,
    views: 1250000,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["校园", "甜宠", "青春"],
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 4)).padStart(2, "0")}-${String(28 - (i % 28)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "平凡的女高中生林小柔，因为父母工作调动不得不转学到首尔的一所高中。在这里，她遇到了校园里的风云人物——学生会长江辰。原本以为只是一次普通的邂逅，却没想到两人的命运早已被红线紧紧相连。从最初的误会到逐渐靠近，从青涩的好感到甜蜜的恋情，林小柔的每一天都充满了心动和惊喜。然而，来自家庭的压力、朋友的误解，以及竞争对手的出现，让这段感情面临重重考验。他们能否跨越所有障碍，守护属于彼此的幸福？",
  },
  {
    id: 2,
    title: "异世界魔法学院",
    author: "朴志浩",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20manga%20cover%2C%20young%20male%20mage%20with%20glowing%20magic%20staff%20in%20a%20mystical%20academy%20setting%2C%20warm%20golden%20and%20emerald%20green%20tones%2C%20magical%20spell%20effects%2C%20manhwa%20illustration%20style%2C%20clean%20composition%2C%20simple%20dark%20navy%20background%20with%20floating%20light%20particles&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    category: "fantasy",
    categories: ["fantasy", "action"],
    description: "普通高中生李浩然意外穿越到魔法世界，在这里他发现自己拥有罕见的全系魔法天赋。从零开始的魔法学院生活，充满冒险与成长。",
    rating: 4.9,
    views: 2380000,
    status: "连载中",
    updateDate: "2026-08-02",
    tags: ["穿越", "魔法", "学院", "冒险"],
    chapters: Array.from({ length: 124 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 5)).padStart(2, "0")}-${String(30 - (i % 30)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "李浩然是一个普通的高中生，成绩平平，唯一的爱好就是看漫画。一天晚上，他在图书馆发现了一本古老的魔法书，打开书页的瞬间，一道耀眼的光芒将他带到了一个完全陌生的世界——艾泽拉斯魔法大陆。在这里，他被检测出拥有千年难遇的全系魔法天赋，被皇家魔法学院破格录取。从最基础的魔法学徒开始，李浩然凭借着自己的努力和智慧，一步步成长为学院最耀眼的新星。然而，隐藏在暗处的邪恶势力已经开始蠢蠢欲动，一场关乎整个世界命运的冒险即将展开。",
  },
  {
    id: 3,
    title: "暗夜追踪者",
    author: "崔敏浩",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20manga%20cover%2C%20dark%20silhouette%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%20at%20night%2C%20neon%20red%20and%20dark%20blue%20color%20contrast%2C%20noir%20atmosphere%2C%20manhwa%20illustration%20style%2C%20mysterious%20mood%2C%20simple%20dark%20background%20with%20rain%20drops&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    category: "thriller",
    categories: ["thriller", "drama"],
    description: "前刑警姜宇镇因一起未解悬案离开警队，成为私家侦探。当他接到一个神秘委托后，发现这与他当年追查的案件有着千丝万缕的联系。",
    rating: 4.7,
    views: 1890000,
    status: "已完结",
    updateDate: "2026-06-15",
    tags: ["悬疑", "推理", "犯罪", "都市"],
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(6 - Math.floor(i / 20)).padStart(2, "0")}-${String(25 - (i % 25)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "姜宇镇曾是首尔警视厅最年轻的刑警队长，前途无量。然而五年前的一起连环失踪案彻底改变了他的人生。那起案件中，他的搭档在追查过程中不幸遇害，案件也因此成为悬案。带着深深的自责，姜宇镇辞去了刑警的工作，开了一家小型私家侦探事务所。直到某天，一位神秘女子带着一份泛黄的档案找上门来，委托他调查一起看似普通的失踪案。当姜宇镇翻开档案的那一刻，他发现这起新案件的所有线索，都指向了五年前那个让他失去一切的夜晚。真相究竟如何？隐藏在暗处的真凶究竟是谁？",
  },
  {
    id: 4,
    title: "美食治愈屋",
    author: "尹秀雅",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cooking%20manga%20cover%2C%20smiling%20young%20woman%20chef%20holding%20a%20beautifully%20plated%20dish%20in%20a%20cozy%20cafe%20kitchen%2C%20warm%20orange%20and%20cream%20tones%2C%20comforting%20atmosphere%2C%20manhwa%20illustration%20style%2C%20simple%20warm%20beige%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    category: "daily",
    categories: ["daily", "comedy"],
    description: "失业女孩苏晴在一条小巷里发现了一家神奇的深夜食堂。这里的每一道菜都能治愈人心，而她的人生也因此发生了改变。",
    rating: 4.6,
    views: 980000,
    status: "连载中",
    updateDate: "2026-08-01",
    tags: ["美食", "治愈", "日常", "温馨"],
    chapters: Array.from({ length: 62 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 10)).padStart(2, "0")}-${String(28 - (i % 28)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "苏晴，27岁，刚刚被公司裁员。在她感到人生最灰暗的时刻，偶然走入了一条从未注意过的小巷。巷子深处有一家挂着暖黄色灯笼的小店——「深夜食堂」。店主是一位沉默寡言但手艺精湛的中年大叔，这里的菜单上永远只有一道菜，但无论你想吃什么，只要你说出来，他就会尽力为你做出来。每一道菜背后，都藏着一个温暖的故事。在这里，苏晴遇到了形形色色的人，听他们讲述各自的喜怒哀乐，也在不知不觉中，治愈了自己受伤的心灵。",
  },
  {
    id: 5,
    title: "剑与魔法战记",
    author: "郑宇成",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20manga%20cover%2C%20warrior%20with%20flaming%20sword%20facing%20a%20giant%20dragon%2C%20epic%20battle%20scene%2C%20red%20and%20gold%20color%20scheme%2C%20dynamic%20composition%2C%20manhwa%20illustration%20style%2C%20simple%20dark%20crimson%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    category: "action",
    categories: ["action", "fantasy"],
    description: "在被魔物侵蚀的大陆上，少年剑士凯恩带着传说中的圣剑踏上冒险之旅。热血沸腾的战斗场面与感人至深的友情故事交织。",
    rating: 4.9,
    views: 3150000,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["冒险", "战斗", "奇幻", "热血"],
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 6)).padStart(2, "0")}-${String(30 - (i % 30)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "在遥远的艾泽拉斯大陆上，魔物横行，人类只能在少数几个要塞城市中苟延残喘。年轻的剑士凯恩从小生活在边境小村，某日在村外的古老遗迹中，他偶然触发了传说中圣剑——「黎明之光」的封印。圣剑选择了他作为新的持有者，赋予他击败魔王、拯救大陆的使命。带着圣剑和伙伴们的信任，凯恩踏上了充满危险与奇遇的旅程。一路上，他结识了精灵弓箭手、矮人锻造师、魔法学院的天才少女，组建了一支强大的冒险者小队。然而，魔王的势力远超他们的想象，隐藏在人类阵营中的叛徒更是让局势雪上加霜。",
  },
  {
    id: 6,
    title: "甜蜜暴击",
    author: "韩艺瑟",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20romance%20manga%20cover%2C%20two%20high%20school%20students%20boy%20and%20girl%20bickering%20with%20exaggerated%20funny%20expressions%2C%20bright%20yellow%20and%20pink%20colors%2C%20playful%20vibe%2C%20manhwa%20illustration%20style%2C%20simple%20white%20background%20with%20pop%20art%20effects&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    category: "comedy",
    categories: ["comedy", "romance"],
    description: "欢喜冤家朴志勋和金多美从幼儿园就开始互掐，谁能想到十年后他们竟然成了邻居兼同班同学？爆笑喜剧爱情故事。",
    rating: 4.5,
    views: 1560000,
    status: "连载中",
    updateDate: "2026-07-30",
    tags: ["喜剧", "校园", "恋爱", "搞笑"],
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 5)).padStart(2, "0")}-${String(28 - (i % 28)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "朴志勋和金多美，从幼儿园开始就是死对头。无论是抢玩具、争第一，还是互相告状，两个人之间的战争从未停止。命运似乎特别喜欢捉弄他们——高中分班，他们被分到了同一个班级；搬家换房子，他们成了隔壁邻居。更要命的是，两家父母居然成了好朋友，经常一起聚餐出游。在被迫朝夕相处的日子里，两个人一边斗嘴互损，一边在不知不觉中对彼此产生了不一样的情愫。但要让这两个嘴硬的家伙承认自己喜欢对方？那可比登天还难！",
  },
  {
    id: 7,
    title: "时光的信笺",
    author: "宋智孝",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20manga%20cover%2C%20young%20woman%20reading%20an%20old%20letter%20under%20a%20tree%20with%20autumn%20leaves%20falling%2C%20nostalgic%20orange%20brown%20and%20gold%20tones%2C%20melancholic%20atmosphere%2C%20manhwa%20illustration%20style%2C%20simple%20warm%20sepia%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    category: "drama",
    categories: ["drama", "romance"],
    description: "整理祖母遗物时，林小曼发现了一封未寄出的信，信中的秘密将她带回三十年前的汉城。跨越时空的感人故事。",
    rating: 4.8,
    views: 1100000,
    status: "已完结",
    updateDate: "2026-05-20",
    tags: ["感人", "时空", "爱情", "家庭"],
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(5 - Math.floor(i / 15)).padStart(2, "0")}-${String(25 - (i % 25)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "林小曼的祖母刚去世不久，她在整理祖母遗物的时候，在一个老旧的首饰盒底层发现了一封发黄的信笺。信是用娟秀的韩文写成的，收信人是一位她从未听祖母提起过的陌生男子。信中记载了一段发生在三十年前汉城的刻骨铭心的爱情故事。随着林小曼一层层揭开信中的秘密，她发现祖母年轻时有着一段被时代和家庭阻挠的初恋，而这封信之所以从未寄出，背后隐藏着一个令人心碎的选择。透过信笺的文字，林小曼仿佛穿越了时空，亲身经历了祖母青春岁月里的欢笑与泪水。",
  },
  {
    id: 8,
    title: "花间集",
    author: "李荷娜",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20BL%20manga%20cover%2C%20two%20handsome%20young%20men%20standing%20back%20to%20back%20among%20flowers%2C%20soft%20purple%20and%20mint%20green%20color%20palette%2C%20elegant%20romantic%20atmosphere%2C%20manhwa%20illustration%20style%2C%20simple%20pastel%20gradient%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    category: "bl",
    categories: ["bl", "romance"],
    description: "花艺师尹智勋遇到了来店里订花的音乐制作人车银优。花语传情，一段浪漫而细腻的BL爱情故事。",
    rating: 4.7,
    views: 870000,
    status: "连载中",
    updateDate: "2026-08-02",
    tags: ["BL", "花艺", "音乐", "甜宠"],
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 8)).padStart(2, "0")}-${String(28 - (i % 28)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "尹智勋在首尔弘大附近经营着一家小小的花艺工作室——「花间集」。他性格温柔内向，每天最大的快乐就是与花为伴。一个下雨的傍晚，一位西装革履却浑身湿透的年轻男子推门而入，想要订一束花送给一位重要的人。这位男子正是音乐制作人车银优，他在业界有着「天才制作人」的称号，却因为性格冷淡孤傲而被称为「冰山」。车银优连续几周都来花店订花，每次都指定不同的花材和花语。尹智勋渐渐发现，这些花语组合起来，似乎在诉说着一段无声的告白。而收花人的名字，正是他自己。",
  },
  {
    id: 9,
    title: "末世生存法则",
    author: "赵贤宇",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20post%20apocalyptic%20action%20manga%20cover%2C%20survivor%20with%20gas%20mask%20in%20destroyed%20cityscape%2C%20dark%20green%20and%20gray%20tones%2C%20gritty%20atmosphere%2C%20manhwa%20illustration%20style%2C%20simple%20dark%20olive%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    category: "action",
    categories: ["action", "thriller"],
    description: "丧尸病毒爆发后，退伍军人韩泰成在末日世界中带领幸存者寻找生机。刺激的生存冒险与人性考验。",
    rating: 4.6,
    views: 2010000,
    status: "连载中",
    updateDate: "2026-08-01",
    tags: ["末世", "丧尸", "生存", "热血"],
    chapters: Array.from({ length: 112 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 5)).padStart(2, "0")}-${String(30 - (i % 30)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "一场突如其来的丧尸病毒席卷全球，人类社会在短短数周内土崩瓦解。退伍特种兵韩泰成在混乱中失去了所有亲人，独自一人在废城中艰难求生。凭借过硬的军事技能和冷静的判断力，他成为了一个幸存者小队的领袖。然而，真正的威胁不仅仅来自丧尸——资源匮乏、人性沦丧、各怀鬼胎的势力相互倾轧，让末日世界变得更加残酷。韩泰成必须在保护自己小队的同时，寻找关于病毒起源的真相，也许那才是人类最后的希望。",
  },
  {
    id: 10,
    title: "猫与我的日常",
    author: "金敏贞",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20manga%20cover%2C%20young%20woman%20cuddling%20with%20three%20cute%20cats%20in%20a%20sunlit%20apartment%2C%20soft%20yellow%20and%20green%20pastel%20colors%2C%20cozy%20relaxing%20vibe%2C%20manhwa%20illustration%20style%2C%20simple%20cream%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    category: "daily",
    categories: ["daily", "comedy"],
    description: "独居女孩和她的三只猫咪的温馨搞笑日常。每只猫都有独特的个性，生活中的小确幸都藏在每天的琐碎时光里。",
    rating: 4.5,
    views: 720000,
    status: "连载中",
    updateDate: "2026-07-28",
    tags: ["猫咪", "治愈", "日常", "温馨"],
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 8)).padStart(2, "0")}-${String(28 - (i % 28)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "29岁的普通上班族林小雅，独自住在首尔一间不大不小的公寓里。她的室友是三只性格迥异的猫咪——高冷傲娇的英短「陛下」、贪吃爱撒娇的橘猫「小橘」、以及精力旺盛喜欢捣蛋的黑猫「小黑」。每天下班回家，推开门的那一瞬间，三只猫咪的反应就决定了今晚的心情。有时候是被小猫们的捣蛋气得哭笑不得，有时候又被它们的撒娇萌得心都化了。在忙碌的城市生活中，这三只毛茸茸的小家伙是她最温暖的陪伴。",
  },
  {
    id: 11,
    title: "星之守护者",
    author: "张载赫",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci-fi%20fantasy%20manga%20cover%2C%20girl%20with%20star%20magic%20powers%20floating%20in%20space%20with%20constellations%20around%20her%2C%20deep%20purple%20and%20silver%20tones%2C%20mystical%20atmosphere%2C%20manhwa%20illustration%20style%2C%20simple%20dark%20starry%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    category: "fantasy",
    categories: ["fantasy", "romance"],
    description: "普通女高中生陈星月在一次流星雨后发现自己拥有了操控星辰之力的能力，同时也被卷入了一场神祇之间的古老战争。",
    rating: 4.7,
    views: 1450000,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["奇幻", "恋爱", "战斗", "星座"],
    chapters: Array.from({ length: 92 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(7 - Math.floor(i / 4)).padStart(2, "0")}-${String(28 - (i % 28)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "陈星月，17岁，普通的高二学生。她最大的爱好就是每天晚上在阳台上仰望星空。某个夜晚，一场百年难遇的流星雨点亮了夜空。陈星月许下了一个愿望，而当她睁开眼时，发现自己的手心里多了一枚闪烁着星光的印记。从那一刻起，她的生活彻底改变了。她发现自己能够感知并操控星辰的力量，同时，一位自称「天界守护者」的神秘少年出现在她面前，告诉她她是被选中的「星之守护者」，肩负着守护人间与天界平衡的重任。",
  },
  {
    id: 12,
    title: "深蓝之恋",
    author: "朴美妍",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20drama%20manga%20cover%2C%20young%20woman%20and%20man%20facing%20each%20other%20at%20seaside%20sunset%2C%20deep%20blue%20and%20coral%20orange%20tones%2C%20emotional%20romantic%20atmosphere%2C%20manhwa%20illustration%20style%2C%20simple%20ocean%20blue%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    category: "romance",
    categories: ["romance", "drama"],
    description: "海洋生物学家韩智恩在济州岛研究海豚时，遇到了神秘的自由潜水员。大海见证了他们之间深邃而纯粹的爱情。",
    rating: 4.8,
    views: 1680000,
    status: "已完结",
    updateDate: "2026-04-10",
    tags: ["海洋", "爱情", "治愈", "济州岛"],
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-${String(4 - Math.floor(i / 20)).padStart(2, "0")}-${String(25 - (i % 25)).padStart(2, "0")}`,
      chapterNumber: i + 1,
    })),
    longDescription: "韩智恩是首尔海洋研究所的一名海洋生物学家，专门研究海豚的行为模式。为了完成博士论文的田野调查，她来到了济州岛的一个海边小村。在那里，她遇到了一个神秘的男人——海俊。海俊是一名自由潜水员，能够不带任何设备潜入数十米深的海底。他对海洋的了解和热爱深深吸引了智恩。两人在碧海蓝天下共同探索海洋的奥秘，一起追踪海豚群，一起在海边看日落。但海俊似乎隐藏着一段不为人知的过去，让他始终无法完全敞开心扉。",
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  if (categorySlug === "all") return comics;
  return comics.filter((c) => c.category === categorySlug || c.categories.includes(categorySlug));
};

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
};

export const getLatestComics = (): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);
};

export const getFeaturedComics = (): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, 4);
};